import { path } from 'ramda';
import moment from 'moment-timezone';
import { createSelector } from 'reselect';
import { getTimezone } from '../../../auth/selectors';

export const getStartDate = path(['reports', 'filters', 'startDate']);
export const getEndDate = path(['reports', 'filters', 'endDate']);

export const getStartDateForAPI = createSelector(
  [getStartDate, getTimezone],
  (startDate, timezone) => moment.tz(startDate, timezone).startOf('day').toJSON()
);

export const getEndDateForAPI = createSelector(
  [getEndDate, getTimezone],
  (endDate, timezone) => moment.tz(endDate, timezone).endOf('day').toJSON()
);
